<template>
	<div>
		<div><h1 hidden=false>{{siteIdF}}</h1> </div>
		<el-form :rules="rules" :inline="true" :model="formData"
		  class="demo-form-inline" ref='formData'>
			<el-form-item label="指标名称" prop="param">
			  <el-select v-model="formData.param" placeholder="请选择指标"   
				multiple   style="margin-left: 20px;">
				   <el-option :label="child.mingCh"  v-for="(child,index) in paramSelect"  
				   :key="index" :value="child.pid"></el-option>
					
			  </el-select>
			<!-- <el-input autofocus="off" class="updatePosInput" size="small" v-model="updatePos.comName"></el-input> -->
			</el-form-item>
		   <el-form-item label="时间">
		      <el-date-picker type="datetime" placeholder="起始时间" v-model="formData.startTime"></el-date-picker>-
		      <el-date-picker type="datetime" placeholder="结束时间" v-model="formData.endTime"></el-date-picker>
		    </el-form-item>
		  <el-form-item>
			<el-button type="primary" @click="onSubmit">查询</el-button>
		  </el-form-item>
		  
		  
		</el-form>
		<div id="chartL" style="width: 100%;height:460px;top:20px;left:10px"></div>
	</div>
</template>

<script>
	import * as echarts from 'echarts';
	export default {
		name: "HisMap",
		
		mounted() {
			
			
			this.initLoad();
			//this.$data.formData.param[0]=this.$data.paramSelect[0].value
			//this.updata(this.$store.state.siteId);
		},
		data() {
			return {
				myChart:null,
				formData: {
					startTime:null,
					endTime:null,
					siteId:null,
					param:[]
				},
				option:{
				  title: {
					text: ''
				  },
				  tooltip: {
					trigger: 'axis'
				  },
				  legend: {
					
				  },
				  grid: {
					left: '3%',
					right: '4%',
					bottom: '6%',
					containLabel: true
				  },
				  toolbox: {
					  
				 //  right: 10,
				 //  feature: {
					// dataZoom: {
					//   yAxisIndex: 'none'
					// },
					// restore: {},
					// saveAsImage: {}
				 //  }
					      
					feature: {
					  saveAsImage: {}
					}
				  },
				  calculable: true,
				  xAxis: {
					type: 'category',
					boundaryGap: false,
					//splitLine: {show: false},
					data: []
				  },
				  yAxis: {
					
					type: 'value'
				  },
				 series: [],
				},
				paramSelect: [],
				rules:{
					
					param:[
						{ required: true, message: '指标不能为空！',trigger: 'blur' }
					],
				}
			}
			
		},
		computed:{
			siteIdF: {
				get:function(){
					//
					//console.log("hachlog:"+this.$store.state.siteId);
					//this.$data.siteId=this.$store.state.siteId;
					this.updata(this.$store.state.siteId);
					
					return this.$store.state.siteId;
				},
				set:function(){
					
					this.$data.siteId=this.$store.state.siteId;
					//this.msg = value; //最后修改了msg    
				}
			 },
		},
		methods:{
			updata(id){
				if(this.$data.siteId!=id){
					this.$data.siteId=id;
					this.$data.formData.siteId=id;
					this.$data.formData.param=[];
					var that=this;
					//this.initEmps();
					//this.initLoad();
					//var myChart = echarts.init(document.getElementById('chartL'));
					this.postRequest('/data/real/hisLine',this.$data.formData).then(resp => {
						
						
						if(resp.error){
							that.$data.option.legend.data=[];
							 that.$data.option.xAxis.data=[];
							 that.$data.option.series=[];
							that.$data.myChart.setOption(that.$data.option,true);
							 that.$data.paramSelect=resp.field;
							 that.$data.formData.param[0]=that.$data.paramSelect[0].pid
							this.$message({
							  type: 'info',//success/warning/info/error/;
							  message: resp.error
							});          
						}else{
							that.$data.option.legend.data=resp.legenddata;
							 that.$data.option.xAxis.data=resp.xAxisdata;
							 that.$data.option.series=resp.series;
							that.$data.myChart.setOption(that.$data.option,true);
							 that.$data.paramSelect=resp.field;
							
							 that.$data.formData.param[0]=that.$data.paramSelect[0].pid
							console.log("option:"+that.$data.option); 
						}
						 
						
					}); 
				}
				
			},
			paramChange(val){
				//
				
			},
			onSubmit(){
				var that=this;
				this.$refs.formData.validate((valid) => {
					this.postRequest('/data/real/hisLine',this.$data.formData).then(resp => {
						if(resp.error){
							that.$data.option.legend.data=[];
							 that.$data.option.xAxis.data=[];
							 that.$data.option.series=[];
							that.$data.myChart.setOption(that.$data.option,true);
							 that.$data.paramSelect=resp.field;
							 //that.$data.formData.param[0]=that.$data.paramSelect[0].pid
							this.$message({
							  type:'info',//info
							  message: resp.error
							});          
						}else{
							
							 that.$data.option.legend.data=resp.legenddata;
							 that.$data.option.xAxis.data=resp.xAxisdata;
							 that.$data.option.series=resp.series;
							 that.$data.myChart.setOption(that.$data.option,true);
							 that.$data.paramSelect=resp.field;
							// that.$data.formData.param[0]=that.$data.paramSelect[0].pid
							console.log(that.$data.option); 
						}
						
					});
				})
				
			},
			initLoad(){
				
				//const chart = this.$refs.chartL
				//const myChart = this.$echarts.init(chart)
				this.$data.myChart = echarts.init(document.getElementById("chartL"));
				var that=this;
				this.$data.myChart.setOption(this.$data.option);
				window.addEventListener("resize", function() {
				          that.$data.myChart.resize()
				})
			}	
		}
	}
</script>

<style>
	.demo-form-inline{
		text-align: left;
	}
</style>
